import React from 'react'
import AgendaComp from './AgendaComp'

export default function Agenda() {
    return (
        <div>
           <AgendaComp text="Introduction" color="lightBlue" margin time={['11:00', '11:05']} /> 
           <AgendaComp text="Clearing mind" color="lightBlue" time={['11:05', '11:10']} /> 
           <AgendaComp text="Setting intention" color="lightBlue" time={['11:10','11:27']} /> 
           <AgendaComp text="Finding the way" color="blue" margin time={['11:27', '11:50']} /> 
           <AgendaComp text="Lighting Questions" color="blue"  time={['11:50', '12:00']} /> 

           <h4 className="break">15 Minutes Energy Booster Break</h4>

           <AgendaComp text="Ideas tank" color="red" margin time={['12:15','13:05']} /> 
           <AgendaComp text="Presenting" color="red" time={['13:05', '13:25']} /> 

           <h4 className="break">15 Minutes Energy Booster Break</h4>
           <AgendaComp text="Let’s decide" color="pink" margin time={['13:40', '14:00']} /> 


        </div>
    )
}
